// This ID is valid only to be used for multi-store search
export const multiRetailerStoreId = 999999
